import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/theme-chalk/src/index.scss';
import 'emui-plus/dist/style.css';
import { createApp } from 'vue';
import JsonViewer from 'vue3-json-viewer';
import 'vue3-json-viewer/dist/index.css';
import '@/assets/css/common.scss';
// 引入公共组件
import ProComponents from '@/components/index';
import pina from '@/stores/store';
import '@/utils/flexiable.js';
import globalVarPlugin from '@/utils/globalVarPlugin';
import App from './App.vue';
import router from './router';

const app = createApp(App);
app.use(pina);
app.use(JsonViewer);
app.use(router);
app.use(ProComponents);
app.use(ElementPlus, { locale: zhCn });
app.use(globalVarPlugin);
app.mount('#app');
